import { useTranslation } from 'react-i18next';
import { Outlet } from 'react-router-dom';

import { PageBreadcrumbs, PageNavigation, useRouteDocumentTitle } from '@client/toolkit';

import { EconomyLayout, EconomyTabs } from './components';
import { EconomyPaths } from './economy.paths';

/**
 * Shell for the portfolio-wide economy pages: scope rail, breadcrumb and the tab bar.
 * Each tab renders through the `Outlet`. Laid out like `ReportPageContent` — breadcrumb,
 * then the page's own navigation, then the content — so there is no page heading; the
 * scope is carried by the breadcrumb and the active tab.
 */
export function EconomyRoute() {
  const { t } = useTranslation('economy');

  // `useRouteDocumentTitle` matches exactly, so the splat is required for the tab routes.
  useRouteDocumentTitle(t('documentTitle'), `${EconomyPaths.Home}/*`);

  return (
    <EconomyLayout>
      <PageNavigation size="none">
        <PageBreadcrumbs>
          <PageBreadcrumbs.Link>{t('sidebar.portfolio')}</PageBreadcrumbs.Link>
        </PageBreadcrumbs>
      </PageNavigation>

      <EconomyTabs />

      <Outlet />
    </EconomyLayout>
  );
}

export default EconomyRoute;
